// Legacy JS module (the verbatim PrivacyPolicy table of contents), no types: typed loosely below.
import AnchorsDefault from 'root/src/client/web/static/PrivacyPolicy/Anchors';
import { legalClasses } from 'root/src/client/v2/_pages/legal/redesign/legalClasses';
const Anchors = AnchorsDefault;
// Privacy table of contents. REUSES the legacy `PrivacyPolicy/Anchors` component verbatim (the source
// of truth for which sections appear, their labels, the nested sub-list, and the anchor wiring), fed
// the redesign `legalClasses` map instead of the MUI `withStyles` one. `Anchors` is prop-driven (only
// takes `classes`) and renders react-scroll `Anchor`s that smooth-scroll to the section `id`s, so no
// data coupling is reused. The links pick up redesign styling from the surrounding `LegalProse`
// (neon-cyan), so we just provide the layout-bearing `listWrapper` / `listOfLinks` classes here.
export const LegalTableOfContents = () => <Anchors classes={legalClasses}/>;
